import { SocialData1Props } from "@/app/types/types"
import Link from "next/link"
 
const SocialMedia = ({ data , customClass }: { data: SocialData1Props[] , customClass?: string }) => {
	return (
		<ul className={`footer_social_media flex items-center justify-center gap-6 ${customClass}`}>
			{data.map((item, i) => (
				<li key={i} className="social_media_item">
					<Link href={item.link} target="_blank" rel="noopener noreferrer" aria-label={item.label}>
						<span aria-hidden="true">{item.icon}</span>
					</Link>
				</li>
			))}
		</ul>
	)
}

export default SocialMedia
